import type {
  AttachmentUploadDataDto,
  AttachmentUploadDto,
  BoletoDownloadDto,
  CmsBoletoDto,
  CmsCompanyDto,
  CmsNfeDto,
  CmsProductDto,
  Configuration,
  FaturaDownloadDto,
  GetFaturaAccessDto,
  IRequest,
  SendContestationDto,
  SendContestationResponseDto,
  SendMessageThreadDto,
  SendUpdateUpsellDto,
  SendUpdateUpsellResponseDto,
  SendUpsellCalculationDto,
  SendUpsellCalculationResponseDto,
  SendUpsellDto,
  SendUpsellResponseDto,
  UpsellCompanyDataResponseDto,
} from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';

export class BusinessManagerRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }
  public getMultipleContracts = async (fleetId: string): Promise<any | null> => {
    const requestData: IRequest = {
      endpoint: 'multiple_contract/fleet',
      method: HttpMethod.GET,
      params: {
        fleet_id: fleetId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };

  public getCompanyUpsellData = async (companyId: string): Promise<UpsellCompanyDataResponseDto> => {
    const requestData: IRequest = {
      endpoint: 'upsell/company',
      method: HttpMethod.GET,
      params: {
        companyId: companyId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public getBoletoTableData = async (companyId: string): Promise<CmsBoletoDto> => {
    const requestData: IRequest = {
      endpoint: 'boleto',
      method: HttpMethod.GET,
      params: {
        id_company: companyId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public getCompanyData = async (companyId: string): Promise<CmsCompanyDto> => {
    const requestData: IRequest = {
      endpoint: 'company',
      method: HttpMethod.GET,
      params: {
        idCompany: companyId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public getProductData = async (companyId: string): Promise<CmsProductDto> => {
    const requestData: IRequest = {
      endpoint: 'product/company',
      method: HttpMethod.GET,
      params: {
        idCompany: companyId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };

  public getNfeTableData = async (companyId: string): Promise<CmsNfeDto> => {
    const requestData: IRequest = {
      endpoint: 'nfe',
      method: HttpMethod.GET,
      params: {
        id_company: companyId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public getAccessFatura = async (companyId: string): Promise<GetFaturaAccessDto> => {
    const requestData: IRequest = {
      endpoint: 'fatura/access',
      method: HttpMethod.GET,
      params: {
        id_company: companyId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public getBoletoPdfData = async (idDoc: string): Promise<BoletoDownloadDto> => {
    const requestData: IRequest = {
      endpoint: 'boleto/pdf',
      method: HttpMethod.GET,
      params: {
        id_doc: idDoc,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public getFaturaDocument = async (idDoc: string): Promise<FaturaDownloadDto> => {
    const requestData: IRequest = {
      endpoint: 'fatura/table',
      method: HttpMethod.GET,
      params: {
        doc_entry: idDoc,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public getTicketTableData = async (companyId: string): Promise<any | null> => {
    const requestData: IRequest = {
      endpoint: 'tickets/list',
      method: HttpMethod.GET,
      params: {
        idCompany: companyId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public getConversationTicketData = async (ticketId: string, companyId?: string): Promise<any | null> => {
    const requestData: IRequest = {
      endpoint: '/tickets/detail',
      method: HttpMethod.GET,
      params: {
        idCompany: companyId,
        ticketId: ticketId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public uploadFileAttachment = async (fileBody: AttachmentUploadDto): Promise<AttachmentUploadDataDto> => {
    const requestData: IRequest = {
      endpoint: '/tickets/upload/attachment',
      method: HttpMethod.POST,
      body: JSON.stringify(fileBody),
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public sendMessageToThread = async (messageBody: SendMessageThreadDto): Promise<void> => {
    const requestData: IRequest = {
      endpoint: '/ticket/conversation',
      method: HttpMethod.POST,
      body: JSON.stringify(messageBody),
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public sendContestation = async (contestationBody: SendContestationDto): Promise<SendContestationResponseDto> => {
    const requestData: IRequest = {
      endpoint: '/ticket/contestacao',
      method: HttpMethod.POST,
      body: JSON.stringify(contestationBody),
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };

  public sendUpsell = async (dealBody: SendUpsellDto): Promise<SendUpsellResponseDto> => {
    const requestData: IRequest = {
      endpoint: '/upsell/deal',
      method: HttpMethod.POST,
      body: JSON.stringify(dealBody),
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };

  public getUpsellCalculation = async (calculationBody: SendUpsellCalculationDto): Promise<SendUpsellCalculationResponseDto> => {
    const requestData: IRequest = {
      endpoint: '/upsell/product/calculate',
      method: HttpMethod.POST,
      body: JSON.stringify(calculationBody),
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };

  public updateStageUpsell = async (updateStageBody: SendUpdateUpsellDto): Promise<SendUpdateUpsellResponseDto> => {
    const requestData: IRequest = {
      endpoint: '/upsell/deal/stage',
      method: HttpMethod.PATCH,
      body: JSON.stringify(updateStageBody),
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };

  public getProductList = async (): Promise<any | null> => {
    const requestData: IRequest = {
      endpoint: 'products',
      method: HttpMethod.GET,
      params: {},
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
}
